import { humanReadableDate } from "../../../../../../helper/dateTimeHelper";

export const formatLeaveHistoryForTable = (leaveHistory: any[] = []) => {
  return leaveHistory.map((item: any, index: number) => {
    return {
      key: index.toString(),
      LeaveType: item.leaveTypeName || "N/A",
      leaveTypeId: item.leaveTypeId,
      LeaveTypes: { value: item.leaveTypeId, name: item.leaveTypeName },
      From: humanReadableDate(item.startDate),
      startDate: item.startDate,
      To: humanReadableDate(item.endDate),
      endDate: item.endDate,
      NoOfDays: `${item.days} Day${item.days > 1 ? "s" : ""}`,
      Status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
      ApprovedBy: item.approverName || "Awaiting Approval",
      ApprovedByImage: item.approverImage || null,
      appoverId: item.approverId || null,
      Roll: item.approverRole || "N/A",
      Image: item.approverImage || null,
      id: item.id,
      reason: item.reason,
      rejectionReason: item.rejectionReason,
      documents: item.documents,
      startDayPart: item.startDayPart || "full",
      endDayPart: item.endDayPart || "full",
      createdAt: item.createdAt || null,
    };
  });
};

export const formatDayPart = (part: string | any) => {
  switch (part) {
    case "first_half":
      return "First Half";
    case "second_half":
      return "Second Half";
    case "full":
      return "Full Day";
    default:
      return part || "--";
  }
};
